import { Component, ChangeDetectionStrategy } from '@angular/core';

import { RequisitionsNotesContainerComponent } from '../../../containers/single-requisition/requisitions-notes-container/requisitions-notes-container.component';
import { NotesPageDataService } from '../../../data/single-requisition/notes-page-data.service';

@Component({
  selector: 'rt-requisitions-notes-page',
  templateUrl: './notes-page.component.html',
  styleUrls: ['./notes-page.component.less'],
  imports: [RequisitionsNotesContainerComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [NotesPageDataService],
})
export class NotesPageComponent {}
